import DependenciesLoader from '../../../model/loader/user-base-entities-loader'
import User               from '../../../model/resource/User'

export default {

  data () {
    return {
      definition: null,
      image:      null
    }
  },

  created () {
    this._initImage()
  },

  methods: {

    /**
     *
     * @private
     */
    _initImage () {
      User.getUserParams((params) => {
        this.image = JSON.parse(params.tUserImageAvatar)
      })
    },

    /**
     *
     * @return {Promise<any>}
     * @private
     */
    _initDefinition () {
      return DependenciesLoader
        .getProfileMenuData((response) => {
          this.definition = response.data[0]
        }, (error) => {
          this.handleApiError(error)
        })
    },

    /**
     *
     * @private
     */
    _open () {
      if (this.definition) {
        return
      }

      this._initDefinition()
    },

    /**
     *
     * @param item
     * @param event
     * @private
     */
    _click (item, event) {
      event.preventDefault()

      let target = this._getTarget(item.EntityTypeName),
          params = { parentDefinition: this.definition.Fields[0] }

      if (!target) {
        alert(
          'Pro EntityTypeName: "'
          + item.EntityTypeName
          + '" není definována cílová stránka')

        return
      }

      this.$refs.holder.classList.remove('show')
      this.$refs.menu.classList.remove('show')
      this.$router.push({ name: target, params: params })
    },

    /**
     *
     * @param entityTypeName
     * @return {*}
     * @private
     */
    _getTarget (entityTypeName) {
      switch (entityTypeName) {
        case 'logout': {
          return 'Logout'
        }

        case 'enuProfileMenu': {
          return 'PageUser'
        }

        default: {
          return null
        }
      }
    }
  }

}
